import { useMemo } from "react";
import { selectGuestBuiltLoyaltyOffers } from "../../redux/selectors/loyaltyOfferSelectors";
import { useAppSelector } from "../useReduxHooks";
import { useLoyaltyContext } from "./useLoyaltyContext";

/** Applicable BOGO / bundle offers the guest builds on the offer page. */
export const useGuestBuiltLoyaltyOffers = () => {
  const { timeZone, mappedOrderType, channel } = useLoyaltyContext();
  const offers = useAppSelector((state) =>
    selectGuestBuiltLoyaltyOffers(state, {
      timeZone,
      mappedOrderType,
      channel,
    })
  );

  return useMemo(() => offers, [offers]);
};
